export const defaultNavGroups = {
  "left": [
    {
      "key": "information",
      "full": "\u4fe1\u606f\u7ba1\u7406",
      "short": "\u4fe1\u606f",
      "links": [
        {
          "text": "Adobe",
          "href": "https://adminconsole.adobe.com/"
        },
        {
          "text": "nVidia \u9a71\u52a8",
          "href": "https://www.nvidia.cn/drivers/"
        },
        {
          "text": "\u817e\u8baf\u4e91",
          "href": "https://cloud.tencent.com/"
        },
        {
          "text": "\u8054\u60f3\u9a71\u52a8",
          "href": "https://newsupport.lenovo.com.cn/driveDownloads_index.html?fromsource=guanwang"
        },
        {
          "text": "\u8054\u60f3\u767e\u5e94",
          "href": "https://baiying.lenovo.com/driveDownload"
        },
        {
          "text": "\u6234\u5c14\u9a71\u52a8",
          "href": "https://www.dell.com/support/home/zh-cn/Products/desktop/optiplex_desktop?app=drivers&c=tw&l=zh&s=dhs"
        },
        {
          "text": "KMS",
          "href": "https://kms.cx/"
        }
      ]
    },
    {
      "key": "development",
      "full": "\u667a\u80fd\u5f00\u53d1",
      "short": "\u667a\u80fd",
      "links": [
        {
          "text": "GitHub",
          "href": "https://github.com/"
        },
        {
          "text": "Cursor",
          "href": "https://cursor.com/"
        },
        {
          "text": "Copilot",
          "href": "https://github.com/features/copilot"
        },
        {
          "text": "Dify",
          "href": "https://dify.ai/"
        },
        {
          "text": "Coze",
          "href": "https://www.coze.com/"
        },
        {
          "text": "Replit",
          "href": "https://replit.com/"
        }
      ]
    },
    {
      "key": "writing",
      "full": "\u6587\u6848\u5199\u4f5c",
      "short": "\u6587\u6848",
      "links": [
        {
          "text": "ChatGPT",
          "href": "https://chatgpt.com/"
        },
        {
          "text": "Claude",
          "href": "https://www.anthropic.com/"
        },
        {
          "text": "Kimi",
          "href": "https://www.kimi.com/"
        },
        {
          "text": "DeepSeek",
          "href": "https://www.deepseek.com/"
        },
        {
          "text": "Gemini",
          "href": "https://gemini.google.com/"
        }
      ]
    }
  ],
  "right": [
    {
      "key": "visual",
      "full": "\u89c6\u89c9\u751f\u6210",
      "short": "\u89c6\u89c9",
      "links": [
        {
          "text": "\u5373\u68a6",
          "href": "https://www.baidu.com"
        },
        {
          "text": "Flow",
          "href": "https://www.google.com/search?q=Google+Flow"
        },
        {
          "text": "Runway",
          "href": "https://runwayml.com/"
        },
        {
          "text": "Pika",
          "href": "https://pika.art/"
        },
        {
          "text": "Firefly",
          "href": "https://firefly.adobe.com/"
        }
      ]
    },
    {
      "key": "audio",
      "full": "\u97f3\u9891\u521b\u4f5c",
      "short": "\u97f3\u9891",
      "links": [
        {
          "text": "ElevenLabs",
          "href": "https://elevenlabs.io/"
        },
        {
          "text": "Suno",
          "href": "https://suno.com/"
        },
        {
          "text": "Udio",
          "href": "https://www.udio.com/"
        },
        {
          "text": "\u9b54\u97f3\u5de5\u574a",
          "href": "https://www.moyin.com/"
        }
      ]
    },
    {
      "key": "office",
      "full": "\u529e\u516c\u63d0\u6548",
      "short": "\u529e\u516c",
      "links": [
        {
          "text": "PDF \u5904\u7406",
          "href": "https://www.ilovepdf.com/zh-cn"
        },
        {
          "text": "Gamma",
          "href": "https://gamma.app/"
        },
        {
          "text": "Perplexity",
          "href": "https://www.perplexity.ai/"
        },
        {
          "text": "\u79d8\u5854",
          "href": "https://metaso.cn/"
        },
        {
          "text": "Notion AI",
          "href": "https://www.notion.com/"
        }
      ]
    }
  ]
};

export const navGroups = defaultNavGroups;

export const defaultPortalCards = [
  {
    "title": "\u6280\u672f\u624b\u8bb0",
    "description": "\u8bb0\u5f55\u5b9e\u6218\u7ecf\u9a8c\u4e0e\u95ee\u9898\u62c6\u89e3\uff0c\u628a\u590d\u6742\u8fc7\u7a0b\u6c89\u6dc0\u6210\u53ef\u590d\u7528\u7684\u6280\u672f\u7b14\u8bb0\u3002",
    "image": "/images/portal-tech-home.webp",
    "alt": "\u6280\u672f\u624b\u8bb0",
    "featured": true,
    "type": "route",
    "to": "/tech-notes"
  },
  {
    "title": "\u5149\u5f71\u97f3\u57df",
    "description": "\u6574\u7406\u89c6\u9891\u4f5c\u54c1\u4e0e\u89c6\u89c9\u8868\u8fbe\uff0c\u8ba9\u4e00\u95ea\u800c\u8fc7\u7684\u7075\u611f\u7559\u4e0b\u6e05\u6670\u75d5\u8ff9\u3002",
    "image": "/images/portal-dev.webp",
    "alt": "\u5149\u5f71\u97f3\u57df",
    "type": "route",
    "to": "/light-videos"
  },
  {
    "title": "\u58f0\u97f3\u7559\u767d",
    "description": "\u6536\u85cf\u65cb\u5f8b\u3001\u7ffb\u5531\u4e0e\u60c5\u7eea\u7247\u6bb5\uff0c\u7ed9\u58f0\u97f3\u7559\u4e00\u5904\u5b89\u9759\u505c\u9760\u3002",
    "image": "/images/portal-visual.webp",
    "alt": "\u58f0\u97f3\u7559\u767d",
    "type": "route",
    "to": "/sound-blank"
  },
  {
    "title": "\u5e38\u7528\u8f6f\u4ef6",
    "description": "\u6c47\u603b\u9ad8\u9891\u8f6f\u4ef6\u3001\u4e0b\u8f7d\u5165\u53e3\u4e0e\u5de5\u5177\u56fe\u6807\uff0c\u67e5\u627e\u548c\u8df3\u8f6c\u66f4\u8f7b\u4fbf\u3002",
    "image": "/images/portal-common-software.webp",
    "alt": "\u5e38\u7528\u8f6f\u4ef6",
    "type": "route",
    "to": "/common-software"
  },
  {
    "title": "\u5c0f\u8303\u65b0\u95fb\u805a\u5408\u7cfb\u7edf",
    "description": "\u805a\u5408 11 \u4e2a\u4e3b\u6d41\u5e73\u53f0\u70ed\u70b9\uff0c\u6bcf 5 \u5206\u949f\u81ea\u52a8\u66f4\u65b0\uff0c\u652f\u6301\u4e3b\u9898\u7b5b\u9009\u3001\u5173\u952e\u8bcd\u68c0\u7d22\u4e0e\u699c\u5355\u5bfc\u51fa\u3002",
    "image": "/images/portal-xfnews-v2.webp",
    "alt": "\u5c0f\u8303\u65b0\u95fb\u805a\u5408\u7cfb\u7edf",
    "type": "external",
    "href": "https://fanjunjie.cn/xfnews/"
  },
  {
    "title": "IT-Tools",
    "description": "\u6536\u7eb3\u9ad8\u9891\u5f00\u53d1\u4e0e\u8fd0\u7ef4\u5c0f\u5de5\u5177\uff0c\u628a\u683c\u5f0f\u8f6c\u6362\u3001\u7f16\u7801\u6821\u9a8c\u548c\u6392\u67e5\u6d41\u7a0b\u653e\u8fdb\u4e00\u4e2a\u8f7b\u4fbf\u5de5\u5177\u7bb1\u3002",
    "image": "/images/ittools.webp",
    "alt": "IT-Tools",
    "type": "external",
    "href": "https://fanjunjie.cn/ittools/"
  },
  {
    "title": "\u5c0f\u8303\u5171\u4eab\u53bb\u6c34\u5370\u5de5\u5177",
    "description": "\u672c\u5730 CPU \u79bb\u7ebf\u53bb\u6c34\u5370\u3001\u56fe\u7247\u4fee\u590d\u3001\u88c1\u526a\u5bfc\u51fa\u4e0e\u683c\u5f0f\u8f6c\u6362\uff0c\u70b9\u51fb\u8fdb\u5165\u5b98\u65b9\u4ea7\u54c1\u9875\u9762\u3002",
    "image": "/images/xfpaint.webp",
    "alt": "\u5c0f\u8303\u5171\u4eab\u53bb\u6c34\u5370\u5de5\u5177",
    "type": "route",
    "to": "/xfpaint"
  },
  {
    "title": "\u7f51\u7ad9\u8bbe\u8ba1\u8d44\u6e90\u5e93",
    "description": "\u6536\u5f55\u4f18\u8d28\u7f51\u9875\u89c6\u89c9\u4e0e\u7248\u5f0f\u7075\u611f\uff0c\u6574\u7406\u6210\u53ef\u56de\u770b\u3001\u53ef\u6d4f\u89c8\u3001\u53ef\u6301\u7eed\u6269\u5145\u7684\u8bbe\u8ba1\u6863\u6848\u5165\u53e3\u3002",
    "image": "/images/awesome-design.webp",
    "alt": "\u7f51\u7ad9\u8bbe\u8ba1\u8d44\u6e90\u5e93",
    "type": "external",
    "href": "https://fanjunjie.cn/design/"
  },
  {
    "title": "OpenItems",
    "description": "\u6c47\u96c6\u5f00\u653e\u9879\u76ee\u3001\u8d44\u6e90\u6761\u76ee\u4e0e\u7075\u611f\u7d22\u5f15\uff0c\u628a\u53ef\u590d\u7528\u5185\u5bb9\u6574\u7406\u6210\u6301\u7eed\u66f4\u65b0\u7684\u5165\u53e3\u3002",
    "image": "/images/openitems.webp",
    "alt": "OpenItems \u5f00\u653e\u9879\u76ee\u7d22\u5f15",
    "type": "external",
    "href": "https://fanjunjie.cn/openitems/"
  },
  {
    "title": "\u80a1\u7968\u5206\u6790",
    "description": "\u805a\u5408\u884c\u60c5\u89c2\u5bdf\u3001\u56fe\u8868\u590d\u76d8\u4e0e\u7b56\u7565\u7814\u7a76\u5165\u53e3\uff0c\u767b\u5f55\u540e\u8fdb\u5165\u4e13\u5c5e\u80a1\u7968\u5206\u6790\u9875\u9762\u3002",
    "image": "/images/stock-analysis.webp",
    "alt": "\u80a1\u7968\u5206\u6790",
    "type": "route",
    "to": "/gupiao"
  }
];

export const portalCards = defaultPortalCards;

const toText = (value = "") => String(value ?? "");

const compactText = (value = "") => toText(value).replace(/\s+/g, " ").trim();

const decodeHtmlEntities = (value = "") =>
  toText(value)
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .replace(/&#(\d+);/g, (_, code) => String.fromCodePoint(Number(code)))
    .replace(/&#x([0-9a-f]+);/gi, (_, code) => String.fromCodePoint(parseInt(code, 16)));

const stripHtml = (value = "") =>
  compactText(
    decodeHtmlEntities(
      toText(value)
        .replace(/<script[\s\S]*?<\/script>/gi, " ")
        .replace(/<style[\s\S]*?<\/style>/gi, " ")
        .replace(/<[^>]+>/g, " ")
    )
  );

const clipText = (value = "", maxLength = 120) => {
  const text = compactText(value);
  return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
};

const blockToSearchText = (block = {}) => {
  if (!block || typeof block !== "object") return "";
  if (block.type === "heading" || block.type === "paragraph") {
    return compactText([block.text, stripHtml(block.html)].filter(Boolean).join(" "));
  }
  if (block.type === "list") return compactText((block.items || []).map((item) => stripHtml(item)).join(" "));
  if (block.type === "image") return compactText([block.alt, block.caption, stripHtml(block.html)].filter(Boolean).join(" "));
  if (block.type === "video") return compactText([block.caption, block.src].filter(Boolean).join(" "));
  if (block.type === "code") return compactText([block.filename, block.language, block.code].filter(Boolean).join(" "));
  if (block.type === "callout") return compactText([block.title, block.text, stripHtml(block.html)].filter(Boolean).join(" "));
  return compactText(Object.values(block).filter((value) => ["string", "number"].includes(typeof value)).join(" "));
};

const noteToSearchText = (note = {}) =>
  compactText([
    note.title,
    note.categoryTitle,
    note.categorySlug,
    note.summary,
    note.heroSummary,
    note.date,
    note.reading,
    note.contentText,
    stripHtml(note.contentHtml),
    ...(Array.isArray(note.contentBlocks) ? note.contentBlocks.map(blockToSearchText) : []),
  ].filter(Boolean).join(" "));

const videoToSearchText = (video = {}) =>
  compactText([
    video.title,
    video.categoryTitle,
    video.categorySlug,
    video.summary,
    video.heroSummary,
    video.date,
    video.duration,
    video.sourceUrl,
    video.bvid,
    video.aid,
  ].filter(Boolean).join(" "));

const audioToSearchText = (track = {}) =>
  compactText([
    track.title,
    track.artist,
    track.categoryTitle,
    track.categorySlug,
    track.summary,
    track.date,
    track.duration,
    track.audioUrl,
  ].filter(Boolean).join(" "));

const softwareToSearchText = (software = {}) =>
  compactText([software.name, software.url, software.logo].filter(Boolean).join(" "));

const isPublicRoute = (item = {}) => item.type !== "route" || !toText(item.to).startsWith("/admin");

const uniqueSearchItems = (items = []) => {
  const seen = new Set();
  return items.filter((item) => {
    if (!isPublicRoute(item)) return false;
    const key = [item.type, item.to || item.href || "", item.category || "", item.title || ""].join("-");
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

export const createSearchItems = (
  navGroups = {},
  techNotes = [],
  lightVideos = [],
  audioTracks = [],
  softwareLinks = []
) => {
  const groups = [...(navGroups.left || []), ...(navGroups.right || [])];
  const portalSearchItems = [
    {
      title: "\u5723\u57df\u7a7a\u95f4",
      category: "\u9996\u9875",
      desc: "\u8fd4\u56de\u7f51\u7ad9\u9996\u9875\uff0c\u6d4f\u89c8\u5168\u90e8\u516c\u5f00\u5185\u5bb9\u5165\u53e3\u3002",
      type: "route",
      to: "/",
      searchText: "\u5723\u57df\u7a7a\u95f4 \u9996\u9875 \u6280\u672f\u624b\u8bb0 \u5149\u5f71\u97f3\u57df \u58f0\u97f3\u7559\u767d TrendRadar \u5168\u7ad9\u5165\u53e3",
    },
    ...defaultPortalCards.map((card) => ({
      title: card.title,
      category: "\u5185\u5bb9\u5165\u53e3",
      desc: card.description,
      type: card.type,
      to: card.to,
      href: card.href,
      searchText: compactText([card.title, card.description, card.alt, card.to, card.href].join(" ")),
    })),
  ];

  const toolSearchItems = groups.flatMap((group) =>
    (group.links || []).map((link) => ({
      title: link.text,
      category: group.full,
      desc: "\u6253\u5f00 " + link.text + " \u76f8\u5173\u7ad9\u70b9\u3002",
      type: "external",
      href: link.href,
      searchText: compactText([group.full, group.short, link.text, link.href].join(" ")),
    }))
  );

  const noteSearchItems = techNotes.map((note) => {
    const searchText = noteToSearchText(note);
    return {
      title: note.title,
      category: note.categoryTitle,
      desc: clipText(note.summary || note.heroSummary || searchText, 120),
      type: "route",
      to: "/tech-notes/" + note.slug,
      searchText,
    };
  });

  const videoSearchItems = lightVideos.map((video) => {
    const searchText = videoToSearchText(video);
    return {
      title: video.title,
      category: video.categoryTitle || "\u5149\u5f71\u97f3\u57df",
      desc: clipText(video.summary || video.heroSummary || searchText, 120),
      type: "route",
      to: "/light-videos/" + video.slug,
      searchText,
    };
  });

  const audioSearchItems = audioTracks.map((track) => {
    const searchText = audioToSearchText(track);
    return {
      title: track.title,
      category: track.categoryTitle || "\u58f0\u97f3\u7559\u767d",
      desc: clipText(track.summary || track.artist || searchText, 120),
      type: "route",
      to: "/sound-blank",
      searchText,
    };
  });

  const softwareSearchItems = softwareLinks.map((software) => {
    const searchText = softwareToSearchText(software);
    return {
      title: software.name,
      category: "\u5e38\u7528\u8f6f\u4ef6",
      desc: clipText(software.url || searchText, 120),
      type: software.url ? "external" : "route",
      href: software.url,
      to: software.url ? undefined : "/common-software",
      searchText,
    };
  });

  return uniqueSearchItems([
    ...portalSearchItems,
    ...noteSearchItems,
    ...videoSearchItems,
    ...audioSearchItems,
    ...softwareSearchItems,
    ...toolSearchItems,
  ]);
};
